// src/pages/nationalities/Nationalities.jsx

import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import NationalitiesTable from "../../components/nationalities/NationalitiesTable";

const Nationalities = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            {/* data table Nationalities */}
            <NationalitiesTable />
        </WrapperSection>
    );
};

export default Nationalities;